<template>
    <div class="bodybox" >
        <!--<p style="line-height: 60px;font-size: 18px">账单列表</p>-->
        <header class="headerBox">
            <el-date-picker
                    size="small"
                    style="width: 250px;margin-right: 50px"
                    v-model="date1"
                    value-format="yyyy-MM-dd"
                    type="daterange"
                    range-separator="-"
                    start-placeholder="开始日期"
                    end-placeholder="结束日期">
            </el-date-picker>

            <el-input style="width: 140px;margin-right: 50px" placeholder="活动名称"  size="small" v-model="center">
            </el-input>

            <div class="btngroup">
                <el-radio size="small" v-model="jiesuan" label="0" border>全部</el-radio>
                <el-radio size="small" v-model="jiesuan" label="1" border>未结算</el-radio>
                <el-radio size="small" v-model="jiesuan" label="2" border>已结算</el-radio>
            </div>

            <el-button  type="warning" size="small" icon="el-icon-search" @click="sousuo">搜索</el-button>


        </header>

        <main>


            <div class="tablehead">
                <p>总销售金额:<span>{{head.money_sum}}元</span></p>
                <p>分成金额:<span>{{head.all_settlement_sum}}元</span></p>
                <p>已结算金额:<span>{{head.settlement_sum}}元</span></p>
                <p>未结算金额:<span>{{head.no_order_sum}}元</span></p>
            </div>

            <table class="table table-bordered table-hover" v-loading="loading2" style="font-size: 14px;">
                <thead>
                <tr>
                    <th>序号</th>
                    <th>活动名称</th>
                    <th>活动时间</th>
                    <th>订单数</th>
                    <th>结算金额(元)</th>
                    <th>结算状态</th>
                </tr>
                </thead>
                <tbody >
                <tr v-if="status">
                    <td>暂无数据</td>
                </tr>
                <tr v-if="!status" v-for="(ta,index) in tabdata" :key="index">
                    <td>{{index+1}}</td>
                    <td>{{ta.group_name}}</td>
                    <td>{{ta.start_time}}至{{ta.end_time}}</td>
                    <td>{{ta.order_sum}}</td>
                    <td>{{ta.settlement_money}}</td>
                    <td>{{ta.settlement}}</td>
                </tr>

                </tbody>

            </table>


            <div class="table-bottom">
                <div>
                    <el-pagination
                            @current-change="fanye"
                            :page-size="pageone"
                            background
                            :current-page="curpage"
                            layout="prev, pager, next"
                            :total="zongt">
                    </el-pagination>
                </div>
                <!--<p style="color: #999;margin-bottom: 15px;font-size: 14px;">共有{{zongt}}条数据</p>-->

            </div>


        </main>

    </div>
</template>

<script>
export default {

    data() {
        return{
            center:'',
            token:'',
            loading2:false,
            jiesuan:'0',
            date1:'',
            pageone:10,
            curpage:1,
            zongt:0,
            tabdata:'',
            status:false,
            head:''

        }
  },
    methods:{
        fanye:function (i) {
            let self=this;
            self.curpage=i;
            self.gonggong()
        },
        sousuo:function () {
            let self=this;
            self.curpage=1;
            self.gonggong()
        },
        gonggong:function () {
            let self=this;
            if(self.date1!=null){
                var time1=self.date1[0]
                var time2=self.date1[1]

                $.ajax({
                    type: 'POST',
                    url: process.env.apiUrl + "saas/settlement/fin_report",
                    data: {
                        token:self.token,
                        start_time:time1,
                        end_time:time2,
                        page:self.curpage,
                        group_name:self.center,
                        settlement_status:self.jiesuan,

                    },
                    beforeSend: function(xhr) {
                        self.loading2=true
                    },
                    success: function (data) {
                        self.loading2=false

                        if(data.status==2){
                            self.status=true
                            self.zongt=0
                        }else{
                            self.status=false
                            self.tabdata=data.data;
                            self.zongt=data.map.count;
                            self.curpage=data.map.page;
                            self.pageone=Number(data.map.pageone);

                        }

                    },
                    error:function (data) {
                        self.$message.error(`分页筛选请求失败!`);
                    }
                });


            }else{
                var time1=''
                var time2=''

                $.ajax({
                    type: 'POST',
                    url: process.env.apiUrl + "saas/settlement/fin_report",
                    data: {
                        token:self.token,
                        start_time:time1,
                        end_time:time2,
                        page:self.curpage,
                        group_name:self.center,
                        settlement_status:self.jiesuan,

                    },
                    beforeSend: function(xhr) {
                        self.loading2=true
                    },
                    success: function (data) {
                        self.loading2=false

                        if(data.status==2){
                            self.status=true
                            self.zongt=0
                        }else{
                            self.status=false
                            self.tabdata=data.data;
                            self.zongt=data.map.count;
                            self.curpage=data.map.page;
                            self.pageone=Number(data.map.pageone);

                        }

                    },
                    error:function (data) {
                        self.$message.error(`分页筛选请求失败!`);
                    }
                });

            }


        }
    },
    mounted:function(){
        var self=this;
//       $.cookie('centre_id','223')
        self.token=$.cookie('token');

        $.ajax({
            type: 'POST',
            url: process.env.apiUrl + "saas/settlement/fin_report",
            data: {
                token:self.token,
            },
            beforeSend: function(xhr) {
                self.loading2=true
            },
            success: function (data) {
                console.log(data)
                self.loading2=false;

                if(data.status==2){
                    self.status=true
                    self.zongt=0
                }else{
                    self.status=false
                    self.zongt=data.map.count;
                    self.curpage=data.map.page;
                    self.pageone=Number(data.map.pageone);
                    self.tabdata=data.data;
                    self.head=data.head;
                }

            },
            error:function (data) {

                self.$message.error(`请求失败!`);
            }
        });






    }

}
</script>


    <style scoped>

    .bodybox{
        padding: 10px;
    }
    .headerBox{
        display: flex;
        display: -webkit-flex;
        line-height: 32px;


    }
    .btngroup .el-radio__input{
        display: none;
    }
    .btngroup{
        margin-right: 50px;
    }
    .tablehead{
        display: flex;
        display: -webkit-flex;
        line-height: 50px;
        height: 50px;

    }
    .tablehead p{
        padding-left: 10px;
        padding-right: 20px;
        font-size: 16px;
    }
    .tablehead p span{
        padding-left: 5px;
        color: #999;
    }
</style>



// WEBPACK FOOTER //
// src/pages/ceping/centercaiwu.vue